var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconXml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1.333C2 .597 2.599 0 3.327 0h12.006L22 6.667v16.002c0 .735-.599 1.331-1.328 1.331H3.328A1.328 1.328 0 012 22.667V1.333z",
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 22h20v.67A1.33 1.33 0 0120.67 24H3.33A1.33 1.33 0 012 22.67V22zM5.732 14.667l1.248-2.048-1.168-1.88h.992l.44.744c.059.106.119.217.18.332l.18.332h.032l.152-.332.152-.332.376-.744h.952l-1.16 1.984 1.248 1.944h-.992l-.48-.776c-.064-.118-.13-.235-.196-.352a10.634 10.634 0 00-.204-.344h-.032c-.059.112-.116.225-.172.34l-.172.356-.416.776h-.96zm4.32 0v-3.928h.76l.064.536h.032c.165-.176.345-.326.54-.448.195-.123.415-.184.66-.184.288 0 .519.061.692.184.173.122.305.296.396.52a3.16 3.16 0 01.584-.504c.203-.134.43-.2.68-.2.416 0 .723.134.92.404.197.269.296.654.296 1.156v2.464h-.928v-2.344c0-.326-.05-.555-.148-.688-.099-.134-.25-.2-.452-.2-.245 0-.52.162-.824.488v2.744h-.92v-2.344c0-.326-.05-.555-.148-.688-.099-.134-.252-.2-.46-.2-.245 0-.52.162-.824.488v2.744h-.92zm7.64.096c-.33 0-.563-.099-.696-.296-.133-.198-.2-.467-.2-.808v-4.64h.92v4.688c0 .112.021.19.064.236.043.045.088.068.136.068h.06a.34.34 0 00.084-.016l.12.688c-.123.053-.285.08-.488.08z",
    fill: "#1A99C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 0v5.334a1.33 1.33 0 001.333 1.333H22L15.333 0z",
    fill: "#C8CDD0"
  }))));
}

export default SvgIconXml;